export const female_features = [ //An array of each Femle Facial Feature's ID, Atlas, and name. There are ??.
  {
    id: 'mask0', 
    atlas: '',
    name: 'No facial feature' //Show name in textbox.
  },
  {
    id: 'feature11',
    atlas: 'atlas01',
    name: '???' /* Fairy makeup */
  },


  
]